import axios from '../../utils/axios';

export type SetCoverPreview = {
    id: string;
};

export const setCover = (preview: SetCoverPreview, bundleId: number | string) =>
    axios.post(`v1/cabinet/set-preview-as-cover/${bundleId}/${preview.id}`, {});
